export const isAndroidApp = (): boolean => typeof HostApp !== 'undefined'
export const isIOSApp = (): boolean => typeof webkit !== 'undefined' && typeof webkit.messageHandlers.HostApp !== 'undefined'
export const isApp = (): boolean => isAndroidApp() || isIOSApp()

// export const isAndroidApp: boolean = typeof HostApp !== 'undefined'
// export const isIOSApp: boolean = typeof webkit !== 'undefined' && typeof webkit.messageHandlers.HostApp !== 'undefined'
// export const isApp: boolean = isAndroidApp || isIOSApp
